/*
 * @Author: Miheev A. V.
 * @Date:   2019-10-14 09:18:51
 * @Last Modified by:   MiheevAV
 * @Last Modified time: 2020-05-13 17:07:44
 */

window.Popper = require('popper.js').default;
window.moment = require('moment');
window.$ = window.jQuery = require('jquery');
window.__localize = require('../lang/' + locale + '.json');
require('bootstrap');
require('bootstrap-select');
import {preload, ucfirst} from './libs/main.func.js';

if(locale == 'ru') {
  require('bootstrap-select/js/i18n/defaults-ru_RU.js');
} else {
  require('bootstrap-select/js/i18n/defaults-en_US.js');
}


var interval;
var progressBarDiv;
var lastProgressBarWidth = [];
var timeInterval;
var recursionCounter = 0;

/**
 * main airport changes function
 * @param  {bool|int} optionProgressBar If true|1 set next airport Else set Current Airport
 * @return {[type]}                   [description]
 */
function changeAirport(optionProgressBar) {
  var li;
  var href;

  if (optionProgressBar == 1) {
    li = $('li.current').removeClass('current').last().next();
    href = li.addClass("current").find('a').attr('href');

  } else {
    li = $('li.current');
    href = li.find('a').attr('href');
  }

  if (li.length == 0) {
    if (optionProgressBar == 1) {
      li = $('.submenu').find('li').first();
      href = li.addClass("current").find('a').attr('href');

    } else {
      href = $(".flex1").attr('aiport_id');
      if (typeof href == 'undefined' || href == false) {
        href = location.pathname;
      } else {
        href = "/" + href;
      }
    }

  } else {

    for (var i = 1; i <= recursionCounter; i++) {
      console.log(href);
      li.removeClass('current');
      li = li.next();
      if (typeof li == 'undefined') {
        li = $('.submenu').find('li').first();
      }
      href = li.addClass("current").find('a').attr('href');
    }
  }

  if (option.reload == true) {
    clearInterval(timeInterval);
    clearInterval(interval);
    window.location.href = href;
    return true;
  }

  let icao = $('.current').data('icao');
  if (typeof icao != 'undefined') {
    var loader = preloader({
      xhrImages: false
    });
    loader.addImage('/img/airports/' + ($('.current').data('icao')) + '.jpg', {
      onComplete: function(content) {
        if (optionProgressBar == 1) {
          // $('#airport_image').fadeTo("400", 0.3);
        }
        getDataFromAjax(href);
      }
    });
    loader.load();
  } else {
    getDataFromAjax(href);
  }
}

/**
 * Set current airport on airports list
 * @param  {int} id identific number of airport
 * @return void
 */
function listSwitcher(id) {
  $('li.current').removeClass('current');
  $('#airport_' + id).addClass('current');
}

/**
 * Load and update display data from ajax
 * @param  {url} href  url
 * @return void or ??? void man
 */
function getDataFromAjax(href) {

  Offline.check();
  clearInterval(interval);

  if (typeof href == 'undefined') {
    return false;
  }

  if (Offline.state == "down") {
    return false;
  }

  href = href + "?content=true&json=true";
  $.ajax({
    url: href,
    complete: function(data, textStatus) {
      clearInterval(interval);
      if (data.responseText == '302' || textStatus == 'error') {
        if (recursionCounter++ < 6) {
          changeAirport(progressBar);
          recursionCounter++;
        } else {
          recursionCounter = 0;
          clearProgress();
          interval = setInterval(progressBar, optionProgressTimer, optionProgressBar);

          // $('#airport_image').fadeTo("400", 1);
        }

        return false;
      } else {
        recursionCounter = 0;

        if (data.responseJSON.option.reload == 1 && data.responseText != '302') {
          location.pathname = "/" + data.responseJSON.thisModel.id;
        }

        option = data.responseJSON.option;
        optionProgressBar = option.progress_bar;
        optionProgressTimer = option.progress_timer * 1000 / 14.706; /**перевод секунд в мс по отрезкам для таймера*/
        locale = data.responseJSON.language;
        if ($("ul.submenu").is(":visible") && optionProgressBar == 1) {
          $('li.current').removeClass('current');
          $('li.next').removeClass('next');
          $('#airport_' + data.responseJSON.thisModel.id).addClass('current');
          if (!$('li.current').is(':last-child')) {
            $('li.current').next().addClass('next');
          } else {
            $("ul.submenu").find('li').first().addClass('next');
          }
        }

        setAirportDataFromJson(data);

        $("#submenu").removeClass('notransition').css({
          left: -$('li.next').position().left
        });
        clearProgress();
        interval = setInterval(progressBar, optionProgressTimer, optionProgressBar);
      }
    }
  });
}

/**
 * Updating main page info after airport changes
 * @param {json} data from ajax '?content=true&json=true'
 */
function setAirportDataFromJson(data) {
  history.pushState({
      page: data.responseJSON.thisModel.id,
      title: data.responseJSON.pageTitle
    },
    data.responseJSON.pageTitle,
    "/" + data.responseJSON.thisModel.id);

  $('title').html(data.responseJSON.pageTitle);
  $('meta[name=description]').attr("content", data.responseJSON.metaDescription);


  if ($('#airport_image').css('background-image') != 'url(/img/airports/' + data.responseJSON.mainImage + '.jpg)') {
    $('#airport_image').fadeOut('100', function() {
      $(this).css('background-image', 'url(/img/airports/' + data.responseJSON.mainImage + '.jpg)').fadeIn('300');
    });
  }


  if ($('#weather_img').find('div').css('background-image').indexOf(data.responseJSON.weather.weather_image) < 0) {
    $('#weather_img').find('div').fadeOut('100', function() {
      $(this).css('background-image', 'url(/img/weather/animated/' + data.responseJSON.weather.weather_image + ')').fadeIn('300');
    });
  }


  if (data.responseJSON.weather.wind_direction != -1) {
    if ($('#wind_speed_image').attr('src') == "/img/arrows/-1.svg") {
      $('#wind_speed_image').attr('src', "/img/arrows/N.svg")
    }
    $('#wind_speed_image').css("transform", "rotate(" + data.responseJSON.weather.wind_direction + "deg)");
  } else {
    $('#wind_speed_image').attr('src', "/img/arrows/-1.svg")
  }

  $('#airportSelect').selectpicker('val', data.responseJSON.airportName);
  $('#airportName').text(data.responseJSON.airportName).attr('value', data.responseJSON.airportName);
  $('#weather_date').text(data.responseJSON.weather.date);
  $('.GMT').text(data.responseJSON.thisModel.timezone);
  $('#temperature').text(data.responseJSON.weather.temperature);
  $('#wind_speed').text(data.responseJSON.weather.wind_speed);
  $('#wind_direction').text(data.responseJSON.windDirection);
  $('#pressure').text(data.responseJSON.weather.pressure);
  $('#metarText').text(data.responseJSON.weather.metar_text);

  if ($('#weather_text').find('span').text() != data.responseJSON.phenomena) {
    $('#weather_text').find('span').fadeOut('100', function() {
      $(this).text(data.responseJSON.phenomena).fadeIn('300');
    });
  }

}

/**
 * Control progress bar
 * @param  {bool} optionProgressBar 1 (show) or 0 (hidden)
 * @return void
 */
function progressBar(optionProgressBar) {

  var f = progressBarDiv.width() / progressBarDiv.parent().width() * 100;
  progressBarDiv.css('transition', 'width .6s ease');
  if (optionProgressBar == 1) {
    progressBarDiv.show();
  } else {
    progressBarDiv.hide();
  }

  progressBarDiv.width(f + 6.8 + "%");
  if (f >= 100) {
    changeAirport(optionProgressBar);
  }
}

/**
 * Clear progress from progress-bar
 * @return void
 */
function clearProgress() {
  progressBarDiv.css('transition', 'none').width("0%");
  $("#progressBar").find('div').width(0);
}

/**
 * Move scrolling airports list
 * @return void
 */
function airportScroll() {
  if ($('li').is('.current') && $("ul.submenu").is(":visible")) {
    $('li.current').next().addClass('next');
    if (style === true) {
      $("#submenu").css({
        left: $('li.next').length ? -$('li.next').position().left : "0"
      });
    }
  } else {
    $('.submenu').find('li').first().addClass('next');
  }
}

/**
 * Close preload screen and start loading simple images
 * @return void
 */
function screenClose() {
  $('#screen').fadeOut("slow", function(el) {
    $("#submenu").animate({
      left: $('li.next').length ? -$('li.next').position().left : "0"
    }, "fast");
    $(el).hide();
  });

  preload();

}

/**
 * After page load checking loading styles file
 * @return void
 */
function screenCloseTimer() {

  if (window.style === true) {
    screenClose()
  } else {
    setTimeout(screenCloseTimer, 200);
  }
}

//Don't touch this!!! Lol :D
window.onload = function() {
  airportScroll();
  screenCloseTimer();
};





//jquery ready
$(function() {

  timeInterval = setInterval(time, 5000);
  window.onpopstate = function(event) {
    if (event.state) {
      location.pathname = "/" + event.state.page;
    } else {
      window.location.href = href;
    }
  };

  //Jquery document ready
  $(document).ready(function() {

    setTimeout(airportScroll, 1000);
    var navU = window.navigator.userAgent;
    if (navU.match(/MSIE/)) {
      //  document.body.innerHTML = "IE DETECTION. PLEASE EXIT IMMEDIATELY";
    }
    // Android Mobile
    var isAndroidMobile = navU.indexOf('Android') > -1 && navU.indexOf('Mozilla/5.0') > -1 && navU.indexOf('AppleWebKit') > -1;

    // Apple webkit
    var regExAppleWebKit = new RegExp(/AppleWebKit\/([\d.]+)/);
    var resultAppleWebKitRegEx = regExAppleWebKit.exec(navU);
    var appleWebKitVersion = (resultAppleWebKitRegEx === null ? null : parseFloat(regExAppleWebKit.exec(navU)[1]));

    // Chrome
    var regExChrome = new RegExp(/Chrome\/([\d.]+)/);
    var resultChromeRegEx = regExChrome.exec(navU);
    var chromeVersion = (resultChromeRegEx === null ? null : parseFloat(regExChrome.exec(navU)[1]));

    // Native Android Browser
    var isAndroidBrowser = isAndroidMobile && (appleWebKitVersion !== null && appleWebKitVersion < 537) || (chromeVersion !== null && chromeVersion < 37);

    if (isAndroidMobile && (appleWebKitVersion !== null && appleWebKitVersion < 38) || (chromeVersion !== null && chromeVersion < 45)) {
      document.body.innerHTML = "OLD ANDROID BROWSER DETECTION. PLEASE EXIT IMMEDIATELY";
    }
  });
  moment.locale(locale);
  interval = setInterval(progressBar, optionProgressTimer, optionProgressBar);

  Offline.options = {
    requests: false,
    reconnect: {
      initialDelay: 10,
      delay: 10
    },
  };

  progressBarDiv = $("#progressBar").find('div');
  time(); //time on Display ON

  //up connect from server
  Offline.on('up', function(event) {
    if (optionProgressBar == 1) {
      clearInterval(interval);
      interval = setInterval(progressBar, optionProgressTimer, optionProgressBar = 1);
    }
  });

  //down connect from server
  Offline.on('down', function(event) {
    if (optionProgressBar == 1) {
      clearInterval(interval);
    }
  });

  // hide or show progress bar
  if (optionProgressBar == 1) {
    $("#progressBar").fadeIn();
  } else {
    $("#progressBar").fadeOut();
  }

  $("#airport").on('click', function(event) {
    if ($("#logo").is(":visible")) {
      $('#airportName').hide();
      $('#airportSelectContainer').show();
    }
  });

  $('#airportSelect').on('hidden.bs.select', function(e, clickedIndex, isSelected, previousValue) {
    var option = $("#airportSelect option:selected");
    var value = option.val();
    if (value != $('#airportName').attr('value')) {
      $('#airportName').text(value).attr('value', value).show();

      var href = option.data('value');
      href += "&json=true";
      var airport_id = option.attr('data-id');

      $.ajax({
        url: href,
        complete: function(data, textStatus) {
          $('#airportName').show();
          $('#airportSelectContainer').hide();
          if (data.responseText == '302' || textStatus == 'error') {
            alert(data.responseText);
          } else {
            listSwitcher(airport_id);
            setAirportDataFromJson(data);
          }

          if (optionProgressBar == 1) {
            clearInterval(interval);
            interval = setInterval(progressBar, optionProgressTimer, optionProgressBar);
          } else {
            clearInterval(interval);
          }
        }
      });
    }

    $('#airportName').show();
    $('#airportSelectContainer').hide();
  });

  $("#sideLeft").on('wheel', function(event) {
    var submenu = $('#submenu');
    var submenuLi = submenu.find('li');
    var liWidth = submenuLi.eq(1).offset().left - submenuLi.eq(0).offset().left;
    var minLeft = submenuLi.last().position().left;

    var liCount = submenuLi.length;

    submenu.addClass('notransition');
    if (submenu.is(':animated')) {
      return false;
    }

    if (event.originalEvent.wheelDelta < 0) {
      if (parseFloat(submenu.css('left')) < -1 * submenuLi.eq(liCount - 1).position().left + parseFloat(submenuLi.last().width())) {
        submenu.stop(true, true).css('left', -1 * submenuLi.eq(liCount - 1).position().left);
      } else {
        submenu.animate({
          left: "-=30vw"
        }, 200, function() {
          if (parseFloat(submenu.css('left')) < -1 * submenuLi.eq(liCount - 1).position().left + parseFloat(submenuLi.last().width())) {
            submenu.stop(true, true).css('left', -1 * submenuLi.eq(liCount - 1).position().left);
          }
        });
      }
    } else {
      if (parseFloat(submenu.css('left')) + liWidth > liWidth * -1) {
        submenu.stop(true, true).css({
          left: "0px"
        });
      } else {
        submenu.animate({
          left: "+=30vw"
        }, 200, function() {
          if (parseFloat(submenu.css('left')) > liWidth) {
            submenu.stop(true, true).css({
              left: "0px"
            });
          }
        });
      }
    }
  });


  $('#status-airports-bar').on('change', function(event) {
    var el = $(this);
    var status = el.attr('status');
    el.attr('status');
    $.ajax({
      url: "/setAirportsBar/" + status,
      method: "GET",
      success: function(data) {
        if (data == 1) {
          $('#sideLeft').show();
          $('#header').attr('style', '');
          el.attr('status', 0);
        } else {
          $('#sideLeft').hide();
          $('#header').css('flex-grow', '0.43');
          el.attr('status', 1);
        }
        clearProgress();
      }
    });
  });

  //set progressbar interval
  $('#status-progress-bar, #status-progress-bar2').on('change', function(event) {
    var el = $(this);
    var status = el.attr('status');
    el.attr('status');
    $.ajax({
      url: "/setProgressBar/" + status,
      method: "GET",
      success: function(data) {
        clearInterval(interval);
        if (data == 1) {
          el.attr('status', 0);
          interval = setInterval(progressBar, optionProgressTimer, optionProgressBar = 1);
          $("#progressBar").fadeIn();
        } else {
          el.attr('status', 1);
          interval = setInterval(progressBar, optionProgressTimer, optionProgressBar = 0);
          $("#progressBar").fadeOut();
        }
        clearProgress();
      }
    });
  });

  //set progressbar interval for main version
  $('.status-progress-bar, #status-progress-bar2').on('click', function(event) {

    var el = $(this);
    var status = el.attr('status');
    el.attr('status');
    $.ajax({
      url: "/setProgressBar/" + status,
      method: "GET",
      success: function(data) {
        clearInterval(interval);
        if (data == 1) {
          el.attr('status', 0).find('span').removeClass('oi-media-play').addClass('oi-media-pause');
          interval = setInterval(progressBar, optionProgressTimer, optionProgressBar = 1);
          $("#progressBar").find('div').show();
        } else {
          el.attr('status', 1).find('span').removeClass('oi-media-pause').addClass('oi-media-play');
          interval = setInterval(progressBar, optionProgressTimer, optionProgressBar = 0);
        }
        clearProgress();
      }
    });
  });

  /**
   * Change airport from menu
   */
  $(".flex1").on('input', function() {
    var val = this.value;
    // $('#airport_image').fadeTo("400", 0.3);
    $('#character option').each(function(el) {
      if ($(this).text().toUpperCase() == val.toUpperCase()) {

        var href = $(this).data('value');
        href += "&json=true";
        var airport_id = $(this).attr('data-id');
        $(".flex1").val('').attr('placeholder', val).attr('aiport_id', airport_id);

        $.ajax({
          url: href,
          //    data: {metarTimer: 18},
          complete: function(data, textStatus) {

            if (data.responseText == '302' || textStatus == 'error') {
              alert(data.responseText);
            } else {
              listSwitcher(airport_id);
              setAirportDataFromJson(data);
            }
            if (optionProgressBar == 1) {
              clearInterval(interval);
              interval = setInterval(progressBar, optionProgressTimer, optionProgressBar);
            } else {
              clearInterval(interval);
            }
            // $('#airport_image').fadeTo("400", 1);
          }
        });
        return false;
      }
    });
  });

  $('body').on('click', '#full-screen-mode, #full-screen-mode2', function(event) {
    try {
      if (!document.fullscreenElement) {
        $('#full-screen-mode,#full-screen-mode2').prop('checked', true);
        document.documentElement.requestFullscreen();
      } else {
        if (document.exitFullscreen) {
          $('#full-screen-mode,#full-screen-mode2').prop('checked', false);
          document.exitFullscreen();
        }
      }
    } catch (err) {
      alert(window.__localize["FC not supported"]);
    }
  });

  $('body').on('focus', '#airportsFind', function() {
    const $this = $(this);
    $this.text('');
  }).on('blur keyup paste input', '#airportsFind', function() {
    var searchText = $(this).text();

    $('#submenu').find('li').each(function(index, el) {

      let text = $(this).text();
      let reg = ".+?" + searchText + ".+?";
      let re = new RegExp(reg, 'gi');
      if (!text.match(re)) {
        $(this).hide();
      } else {
        $(this).show();
      }
    });
  });

  /**
   * Set the time on header, and checking status main interval, safe him
   * @return void
   */
  function time() {

    if (optionProgressBar == 1) {

      if (Offline.state == "up") {
        Offline.check();
      }

      if (progressBarDiv.width() == lastProgressBarWidth[lastProgressBarWidth.length - 1] &&
        progressBarDiv.width() == lastProgressBarWidth[lastProgressBarWidth.length - 6] &&
        progressBarDiv.width() == lastProgressBarWidth[lastProgressBarWidth.length - 11] &&
        progressBarDiv.width() == lastProgressBarWidth[lastProgressBarWidth.length - 16] &&
        Offline.state == "up") {
        clearInterval(interval);
        interval = setInterval(progressBar, optionProgressTimer, optionProgressBar);
      }

      lastProgressBarWidth.push(progressBarDiv.width());
      if (lastProgressBarWidth.length > 20) {
        lastProgressBarWidth.shift();
      }
    }

    let now = moment();
    let hours = now.format('HH');
    let minutes = now.format('mm');
    let seconds = now.format('ss');
    if (option.burnout == 1) {
      let optValues = option.burnout_timer.split(':')
      if (hours == optValues[0] && minutes == optValues[1] && seconds < 5) {
        $('#halfOpacityScreen').fadeTo("400", 0.5);
        setTimeout("$('#halfOpacityScreen').fadeTo('400', 0);document.location.reload(true);", 2000)
      } else {
        if ($("#halfOpacityScreen").is(":visible") == true) {
          $("#halfOpacityScreen").hide();
        }
      }
    }

    let text = now.format('dd');
    text = ucfirst(text) + " <span>" + hours + ":" + minutes + "</span> ";
    $('#displayTime').html(text);
  }
});
